import { Button } from 'antd';
import BCDivider from '../BCDivider';
import { IButtonGroupProps } from './entities';
import Styles from './assets/styles.scss';

const ButtonGroup = Button.Group;

const BCButtonGroup = (props: IButtonGroupProps) => {
	Styles;
	return (
		<>
			{props.holder ? <span>#</span> : null}
			<ButtonGroup className={props.className}>{props.children}</ButtonGroup>
			{props.divider ? <BCDivider type="vertical" /> : null}
		</>
	);
};
export default BCButtonGroup;

export { IButtonGroupProps };
